import type { LucideIcon } from 'lucide-react'

/** Bento card for the /business-model page (earn category or refusal pledge). */
export function EngagementCard({
  icon: Icon,
  label,
  desc,
  share,
}: {
  icon: LucideIcon
  label: string
  desc: string
  share?: string
}) {
  return (
    <div className="rounded-3xl border border-border bg-bg-elevated p-6">
      <div className="flex items-center justify-between">
        <Icon className="h-5 w-5 text-text-muted" strokeWidth={1.5} aria-hidden />
        {share ? <span className="font-mono text-sm text-text-muted">{share}</span> : null}
      </div>
      <h3 className="mt-4 text-lg font-medium">{label}</h3>
      <p className="mt-1 text-sm text-text-muted">{desc}</p>
    </div>
  )
}
